import * as React from 'react';
import { NotificationBar, NotificationSubTitle, NotificationTitle } from './NotificationBar';
import moment from 'moment-timezone';
import { observable } from 'mobx';
import { UpdateSubscriptionNotificationState } from './states/UpdateSubscriptionNotificationState';
import { SubscriptionIndexView } from '../../../types/subscriptions';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

function shouldShowUpdateSubscriptionNotification(subscription: SubscriptionIndexView) {
    const oneMonthSince = moment().add(1, 'month');
    // 1ヶ月前にならないとnext_payment_dateが入力されないので対象外
    if (subscription.next_payment_date == null) {
        return false;
    }
    // プランを変更した場合は、1ヶ月未満でもアラートをださない
    if (subscription.will_change_plan == true) {
        return false;
    }
    if (subscription.duration_month < 6) {
        return false;
    }
    return moment(subscription.next_payment_date).isBefore(oneMonthSince);
}

function durationName(subscription: SubscriptionIndexView) {
    if (subscription.duration_month == 6) {
        return '半年';
    }
    if (subscription.duration_month == 12) {
        return '1年';
    } else {
        return `${subscription.duration_month}ヶ月`;
    }
}

@observer
export class UpdateSubscriptionNotification extends React.Component {
    @observable pageState = new UpdateSubscriptionNotificationState();

    componentDidMount(): void {
        this.pageState.init();
    }

    render() {
        const subscriptions = this.pageState.subscriptions;
        const currentUserState = GlobalStatesV3.currentUser;
        // 非ログインユーザには表示しない
        if (!currentUserState.isSignedIn()) {
            return null;
        }
        const { currentUser } = currentUserState;
        // 未加入のユーザには表示しない
        if (!currentUser.strict_joined_date) {
            return null;
        }
        // まだプランが開始されていない場合には表示しない
        if (moment(currentUser.strict_joined_date).isAfter(moment())) {
            return null;
        }
        return (
            <>
                {subscriptions.getOrElse([]).map((subscription: SubscriptionIndexView) => {
                    if (shouldShowUpdateSubscriptionNotification(subscription)) {
                        return (
                            <NotificationBar type="warning" id="update-subscription-notification">
                                <NotificationTitle>
                                    {durationName(subscription)}プランの会員期間が後{moment(
                                        subscription.next_payment_date
                                    ).diff(moment(), 'days')}日で終了します。
                                </NotificationTitle>
                                <NotificationSubTitle>
                                    その後は同じプランにて自動で継続されます。継続をご希望されない場合は、マイページからプラン変更or退会のお手続きをお願いいたします。
                                </NotificationSubTitle>
                            </NotificationBar>
                        );
                    }
                })}
            </>
        );
    }
}
